

function Csae() {
    return (
        <>
            <section className='other-pages'>
                <div className="container">
                    <h3>Statement on CSAE Prevention</h3>
                </div>
            </section>
            <section className='other-pages-details'>
                <div className="container">
                    <h6 className='mb-4'>Our app strictly prohibits any form of child sexual abuse material (CSAM) or exploitation. We are fully committed to user safety and follow Google Play’s policies and applicable laws.</h6>
                    <div className='mb-3'>
                        <h5 className='mb-3'>Here’s how we prevent CSAE in our app:</h5>
                        <ul>
                            <li>Age Restriction: Our app is not targeted at children. Users must be 13+ to use the platform, and this is clearly stated in the app’s terms of use.
                            </li>
                            <li>User Reporting Tools: Users can easily report inappropriate content or behavior through in-app tools.

                            </li>
                            <li>Content Moderation: All user-generated content (profiles, messages, posts, events) is monitored using a combination of automated filters and manual review by moderators.

                            </li>
                            <li>Account Enforcement: We immediately suspend or ban accounts that violate safety rules, including any signs of CSAE.


                            </li>
                            <li>Law Enforcement Cooperation: We cooperate with law enforcement and organizations like NCMEC (National Center for Missing & Exploited Children) and respond to valid legal requests regarding user activity.

                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Csae